const l = "_label_gtzhc_1", o = {
  label: l,
  "label--color-pink": "_label--color-pink_gtzhc_8",
  "label--color-green": "_label--color-green_gtzhc_13",
  "label--color-brown": "_label--color-brown_gtzhc_18",
  "label--color-gray": "_label--color-gray_gtzhc_23",
  "label--color-blue": "_label--color-blue_gtzhc_28",
  "label--color-yellow": "_label--color-yellow_gtzhc_33"
};
export {
  o as default,
  l as label
};
//# sourceMappingURL=index.es575.js.map
